import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IScheduleDocInfo } from 'src/app/ViewModel/ScheduleDocumentModel';

@Component({
  selector: 'app-attachment-dialog',
  templateUrl: './attachment-dialog.component.html',
  styleUrls: ['./attachment-dialog.component.css']
})
export class AttachmentDialogComponent implements OnInit {
  public isDocumentView: boolean = true;
  public is_Schedule_Document: boolean = false;
  public viewData: any[] = [];
  public viewSchData: IScheduleDocInfo | undefined | null;

  constructor(public dialogRef: MatDialogRef<AttachmentDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.isDocumentView = this.data.isDocumentView;
    this.is_Schedule_Document = this.data.is_Schedule_Document;
    this.viewData = !this.data.is_Schedule_Document ? this.data.viewData : [];
    this.viewSchData = this.data.is_Schedule_Document ? this.data.viewData : null;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
